// extracted by mini-css-extract-plugin
module.exports = {"EcoResponsable__block":"EcoResponsable__block_1VgG","EcoResponsable__content":"EcoResponsable__content_hQHz"};